var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cfdis-related-return box wrapper-document-comments" },
    [
      _c(
        "h1",
        { staticClass: "title is-4 has-text-primary title-document-comments" },
        [_vm._v("\n    Comentarios\n  ")]
      ),
      _c("AppInputField", {
        attrs: {
          id: "voucherComments",
          name: "voucherComments",
          placeholder: "Comentarios",
          value: _vm.comment,
          disabled: _vm.disabled
        },
        on: { input: _vm.onChange, change: _vm.onChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }